import React, { memo } from "react";
import { Skeleton } from "@/components/ui/adapters";

const rows = [
  { outgoing: false, width: "w-48", height: "h-16" },
  { outgoing: true, width: "w-36", height: "h-10" },
  { outgoing: false, width: "w-64", height: "h-20" },
  { outgoing: false, width: "w-40", height: "h-10" },
  { outgoing: true, width: "w-56", height: "h-16" },
];

const MessageHistorySkeleton = memo(function MessageHistorySkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading messages"
      aria-busy="true"
      className="pointer-events-none absolute inset-0 flex flex-col justify-end gap-4 overflow-hidden px-4 py-4"
    >
      {rows.map(({ outgoing, width, height }, index) => (
        <div
          key={index}
          aria-hidden="true"
          className={`flex shrink-0 items-end gap-2 ${outgoing ? "justify-end" : "justify-start"}`}
        >
          {!outgoing && <Skeleton className="size-8 shrink-0 rounded-full" />}
          <Skeleton className={`${width} ${height} max-w-[70%] rounded-2xl`} />
        </div>
      ))}
    </div>
  );
});

export default MessageHistorySkeleton;
